<template lang="html">

  <footer class="footer">

    <div class="container row-center">
      <router-link :to="$t('enlaces.avisolegal')" target="_blank">Aviso legal</router-link>
      <router-link :to="$t('enlaces.politica_cookies')" target="_blank">Política de cookies</router-link>
      <a href="mailto:blog@launionhacelafuerza.es">Contacto</a>
    </div>

    <p class="version">v.{{version}}</p>
  </footer>

</template>

<script lang="js">

  

  import {mapGetters} from 'vuex'

  export default  {
    name: 'app-footer',
    computed:{
      ...mapGetters({
        version : 'getVersion'
      })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/parts/footer.vue